module.exports = __webpack_public_path__ + "img/vertical_4_3_9005.5c038c51.png";